import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "../components/ScoreDisplay.css";

import DefBG4 from "../images/PDFImages/Defensive Shield - Platinum.png";
import DefBG3 from "../images/PDFImages/Defensive Shield - Gold.png";
import DefBG2 from "../images/PDFImages/Defensive Shield - Silver.png";
import DefBG1 from "../images/PDFImages/Defensive Shield - Bronze.png";
import DefFG4 from "../images/PDFImages/Defensive Circle - Platinum.png";
import DefFG3 from "../images/PDFImages/Defensive Circle - Gold.png";
import DefFG2 from "../images/PDFImages/Defensive Circle - Silver.png";
import DefFG1 from "../images/PDFImages/Defensive Circle - Bronze.png";

import EffBGA from "../images/PDFImages/ClockBG.png";
import EffFG4 from "../images/PDFImages/Efficiency Face - Platinum.png";
import EffFG3 from "../images/PDFImages/Efficiency Face - Gold.png";
import EffFG2 from "../images/PDFImages/Efficiency Face - Silver.png";
import EffFG1 from "../images/PDFImages/Efficiency Face - Bronze.png";

import OffBG4 from "../images/PDFImages/Offensive Flag - Platinum.png";
import OffBG3 from "../images/PDFImages/Offensive Flag - Gold.png";
import OffBG2 from "../images/PDFImages/Offensive Flag - Silver.png";
import OffBG1 from "../images/PDFImages/Offensive Flag - Bronze.png";
// import OffFG from "../images/PDFImages/Offensive Circle- Silver.png";
import OffFG1 from "../images/PDFImages/Offensive Circle- Platinum.png";
import OffFG2 from "../images/PDFImages/Offensive Circle- Gold.png";
import OffFG3 from "../images/PDFImages/Offensive Circle- Silver.png";
import OffFG4 from "../images/PDFImages/Offensive Circle- Bronze.png";

import TotalBG1 from "../images/PDFImages/Total Score - Bronze.png";
import TotalBG2 from "../images/PDFImages/Total Score - Silver.png";
import TotalBG3 from "../images/PDFImages/Total Score - Gold.png";
import TotalBG4 from "../images/PDFImages/Total Score - Platinum.png";

function ScorePercentDisplayBG(props) {
  const images = {
    Defense: {
      Platinum: { BG: DefBG4, FG: DefFG4 },
      Gold: { BG: DefBG3, FG: DefFG3 },
      Silver: { BG: DefBG2, FG: DefFG2 },
      Bronze: { BG: DefBG1, FG: DefFG1 },
    },
    Offense: {
      Platinum: { BG: OffBG4, FG: OffFG1 },
      Gold: { BG: OffBG3, FG: OffFG2 },
      Silver: { BG: OffBG2, FG: OffFG3 },
      Bronze: { BG: OffBG1, FG: OffFG4 },
    },
    Efficiency: {
      Platinum: { BG: EffBGA, FG: EffFG4 },
      Gold: { BG: EffBGA, FG: EffFG3 },
      Silver: { BG: EffBGA, FG: EffFG2 },
      Bronze: { BG: EffBGA, FG: EffFG1 },
    },
    Total: {
      Platinum: { BG: TotalBG4, FG: "" },
      Gold: { BG: TotalBG3, FG: "" },
      Silver: { BG: TotalBG2, FG: "" },
      Bronze: { BG: TotalBG1, FG: "" },
    },
  };
  //    console.log(props.chartType, props.stars.Rank);
  let bg = "";
  let fg = "";
  if (props.stars.Rank !== undefined) {
    bg = images[props.chartType][props.stars.Rank].BG;
    fg = images[props.chartType][props.stars.Rank].FG;
  }
  let mgClass = "";
  let textClass = "";
  let subtext = `(out of ${props.maxValue})`;
  let stroke = 20;
  let curValue = props.curValue;
  // let starColor;

  // if (props.stars !== undefined) {
  //   switch (props.stars.Rank) {
  //     case "Platinum":
  //       starColor = "#EEBA2B";
  //       break;
  //     case "Gold":
  //       starColor = "#EEBA2B";
  //       break;
  //     case "Silver":
  //       starColor = "#C0C0C0";
  //       break;
  //     case "Bronze":
  //       starColor = "#AC663E";
  //       break;
  //     default:
  //       starColor = "#AC663E";
  //   }
  // }

  switch (props.chartType) {
    case "Offense":
      mgClass = "offmg";
      textClass = "offText";
      break;
    case "Efficiency":
      mgClass = "effmg";
      textClass = "effText";
      subtext = "Point Deduction";
      curValue = props.maxValue - props.curValue;
      break;
    case "Total":
      mgClass = "totmg";
      textClass = "totText";
      subtext = "";
      break;
    default:
      mgClass = "defmg";
      textClass = "defText";
  }

  // function makeStars() {
  //   let colorStar = "";
  //   let whiteStar = "";
  //   let rv;
  //   if (props.stars != undefined) {
  //     for (let i = 0; i < 3; i++) {
  //       if (i <= props.stars.Stars) {
  //         colorStar += "★";
  //       } else {
  //         whiteStar += "★";
  //       }
  //     }
  //     // console.log(props.stars.Rank, colorStar);
  //   }
  //   return (
  //     <>
  //       <span className="star" style={{ color: starColor }}>
  //         {colorStar}
  //       </span>
  //       <span
  //         className="star"
  //         style={
  //           props.stars.Rank === "Silver"
  //             ? { color: "#ffffff" }
  //             : { color: "#C0C0C0" }
  //         }>
  //         {whiteStar}
  //       </span>
  //     </>
  //   );
  // }

  return (
    <div className="scoreImgContainer" id={`Display_${props.chartType}`}>
      <img
        src={bg}
        className="bg"
        alt="represents the type of score, Shield for defense, flag for offense, clock for efficiency or badge for total"></img>
      <div className={mgClass}>
        {props.chartType === "Total" ? (
          props.curValue
        ) : (
          <CircularProgressbar
            value={curValue}
            maxValue={props.maxValue}
            strokeWidth={stroke}
            text={props.curValue === 0 ? "0" : props.curValue}
            styles={buildStyles({
              textColor: "#07115A",
              pathColor: "#7FBCE1",
              strokeLinecap: "butt",
            })}
          />
        )}
      </div>
      {props.chartType !== "Total" ? (
        <img
          src={fg}
          className={`fg ${props.stars.Rank.toLowerCase()}`}
          alt="a metal ring that denotes the level of the score, bronze, silver, gold or platinum"
        />
      ) : (
        <></>
      )}
      {/* {props.chartType !== "Total" && props.chartType !== "Efficiency" ? (
        <div className={`Stars S_${props.chartType}`}>{makeStars()}</div>
      ) : (
        <></>
      )} */}
      <div className={textClass}>{subtext}</div>
    </div>
  );
}

export default ScorePercentDisplayBG;
